import { Box, VStack } from "@chakra-ui/layout";
import { useField } from "formik";
import { FC, useCallback, useEffect, useState } from "react";

import { FormikTextField } from "~/src/components/common/forms/FormikTextField";

const previewImgSx = {
  "& img": {
    maxWidth: "60px",
    maxHeight: "60px",
    objectFit: "contain",
    display: "block",
    marginTop: "2px",
    marginLeft: "auto",
    marginRight: "auto",
  },
};

type Props = {
  /** Formik path for the image URL string (e.g. `popups.0.popupImages.2.imageUrl`). */
  name: string;
};

/** URL text field + remote thumbnail; `key` on `img` remounts when the URL changes so the preview reloads. */
export const PopupImportImageUrlFieldCell: FC<Props> = ({ name }) => {
  const [{ value }] = useField<string>(name);
  const trimmed = (value ?? "").trim();
  const [showPreview, setShowPreview] = useState(true);

  useEffect(() => {
    setShowPreview(true);
  }, [trimmed]);

  const handleImgError = useCallback(() => {
    setShowPreview(false);
  }, []);

  return (
    <VStack align="stretch" spacing="6px" minW="0">
      <FormikTextField
        mode="fill"
        type="text"
        name={name}
        placeholder="https://..."
      />
      <Box minW="0" sx={previewImgSx}>
        {trimmed && showPreview ? (
          <img key={trimmed} src={trimmed} alt="" onError={handleImgError} />
        ) : null}
      </Box>
    </VStack>
  );
};
